<template>
  <div class="mt-4 text-right">
    <nav
      class="isolate inline-flex -space-x-px rounded-md shadow-sm bg-white"
      aria-label="Pagination"
    >
      <a
        @click="prevPage(current_page)"
        class="cursor-pointer relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
      >
        <span class="sr-only">Previous</span>
        <i class="fas fa-chevron-left" aria-hidden="true" />
      </a>

      <template
        v-for="page in letters"
        :key="'num_page_' + page"
      >
        <a
          @click="changePage(page)"
          aria-current="page"
          :class="
            page == current_page
              ? 'relative z-10 inline-flex items-center bg-lime-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lime-600'
              : 'cursor-pointer relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
          "
          >{{ page }}</a
        >
      </template>

      <a
        @click="nextPage(current_page)"
        class="cursor-pointer relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
      >
        <span class="sr-only">Next</span>
        <i class="fas fa-chevron-right" aria-hidden="true" />
      </a>
    </nav>
  </div>
</template>
<script>
export default {
  name: "TablePaginator",
  data() {
    return {
      current_page: "A",
      begin_available_pages: [3],
      end_available_pages: [3],
      num_pages: 0,
      letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
    };
  },
  props: {
    modelValue: null,
    init_current_page: { type: String, default: "A" },
  },
  methods: {
    changePage(page) {
      this.current_page = page;
    },
    prevPage(page) {
      let index = this.letters.indexOf(page)
      if (index == 0) return;

      this.current_page = this.letters[index - 1];
    },
    nextPage(page) {
      let index = this.letters.indexOf(page)
      if (index == this.letters.length - 1) return;

      this.current_page = this.letters[index + 1];
    },
  },
  created() {
  },
  watch: {
    current_page: function (newValue) {
      this.$emit("update:modelValue", newValue);
    },
  },
};
</script>
